export const gridColumnsCalculator = (layer, device) => {
  if (device === "desktop") {
    if (layer % 4 === 0) {
      return 4;
    } else if (layer % 4 === 1) {
      return 3;
    } else if (layer % 4 === 2) {
      return 2;
    } else {
      return 1;
    }
  } else if (device === "tablet" || device === "miniTablet") {
    if (layer % 3 === 0) {
      return 3;
    } else if (layer % 3 === 1) {
      return 2;
    } else {
      return 1;
    }
  }
};
